import { observable, makeObservable } from 'mobx';

export default class Filter {
  title;

  name;

  id;

  selected = false;

  product_count = 0;

  slug = '';

  constructor(object) {
    makeObservable(this, {
      title: observable,
      name: observable,
      id: observable,
      selected: observable,
      product_count: observable,
      slug: observable
    });

    this.id = object.sys.id;
    this.name = object.name.trim();
    this.title = object.title.trim();
    this.selected = object.selected ? object.selected : false;
    this.facet_category = object.facet_category;
    this.product_count =
      object.product_count != undefined ? object.product_count : 0;
    this.slug = object.slug;
  }
}
